import { useState } from 'react';
import { ChevronRight, ArrowDown, ArrowUp, AlertTriangle } from 'lucide-react';

const DIRECTION_META = {
  in:     { Icon: ArrowDown,     tone: 'text-emerald-600 dark:text-emerald-400', label: 'IN' },
  out:    { Icon: ArrowUp,       tone: 'text-sky-600 dark:text-sky-400',         label: 'OUT' },
  system: { Icon: AlertTriangle, tone: 'text-amber-600 dark:text-amber-400',     label: 'SYS' },
};

function formatTime(iso) {
  try {
    const d = new Date(iso);
    return d.toISOString().slice(11, 23);
  } catch { return iso; }
}

export default function TerminalRow({ row, showDevice = true }) {
  const [open, setOpen] = useState(false);
  const meta = DIRECTION_META[row.direction] || DIRECTION_META.system;
  return (
    <li className="font-mono text-[11px] leading-relaxed px-3 py-1.5 border-b border-slate-100 dark:border-slate-800/60 hover:bg-slate-50 dark:hover:bg-slate-800/40">
      <button type="button" onClick={() => setOpen(o => !o)} className="w-full text-left flex gap-2 items-start">
        <ChevronRight size={12} className={`mt-0.5 transition-transform ${open ? 'rotate-90' : ''} text-slate-400`} />
        <span className="text-slate-400 tabular-nums">{formatTime(row.ts)}</span>
        <span className={`font-bold ${meta.tone} w-7`}>{meta.label}</span>
        {showDevice && (
          <span className="text-slate-600 dark:text-slate-300 truncate max-w-[160px]">{row.deviceName ?? '—'}</span>
        )}
        <span className="text-slate-500 dark:text-slate-400">{row.subtype}</span>
        <span className="text-slate-700 dark:text-slate-200 flex-1 truncate">{row.summary}</span>
      </button>
      {open && (
        <pre className="mt-1 ml-8 p-2 bg-slate-100 dark:bg-slate-900/80 rounded text-[10px] overflow-x-auto">
          {JSON.stringify(row.details, null, 2)}
        </pre>
      )}
    </li>
  );
}
